import api from "./api";
import { API_ENDPOINTS } from "../utils/constants";

export const grievanceService = {
  getAllGrievance: async (params = {}) => {
    try {
      const response = await api.get(API_ENDPOINTS.GRIEVANCES, { params });

      return response;

    } catch (error) {
      throw error;
    }
  },

  createGrievance: async (grievanceData) => {
    try {
      const userId = localStorage.getItem("userId");
      if (userId) {
        grievanceData.append("userId", userId);
      }
      const response = await api.post(API_ENDPOINTS.GRIEVANCES, grievanceData);
      return response;
    } catch (error) {
      throw error;
    }
  },
  updateGrievance: async (id, grievanceData) => {
    try {
      const response = await api.put(`${API_ENDPOINTS.GRIEVANCES}/${id}`, grievanceData);
      return response;
    } catch (error) {
      throw error;
    }
  },
  getStatusOptions: async () => {
    try {
      const response = await api.get(`${API_ENDPOINTS.GRIEVANCES}/status-options`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  getComplaintTypesOptions: async () => {
    try {
      const response = await api.get(`${API_ENDPOINTS.GRIEVANCES}/complaint-types`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  getIssueTypes: async () => {
    try {
      const response = await api.get(`${API_ENDPOINTS.GRIEVANCES}/issue-types`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
